import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import BackIcon from "../icons/BackIcon";

interface Props {
	/**
	 * Navigation path is used by default if href is not provided.
	 * Uses history back by default.
	 */
	href?: string;
	onClick?: () => any;
}

export const Back: React.FC<Props> = ({ href, onClick }) => {
	const navigate = useNavigate();

	function handleClick() {
		if (href) {
			navigate(href);
		} else if (onClick) {
			onClick();
		} else {
			navigate(-1);
		}
	}

	return (
		<Styles onClick={handleClick}>
			<BackIcon />
			Tillbaka
		</Styles>
	);
};

const Styles = styled.a`
	cursor: pointer;
	display: flex;
	justify-content: flex-start;
	align-items: center;

	font-weight: 500;

	text-decoration: none;
	font-size: ${(props) => props.theme.font.small};

	svg {
		margin-right: 5px;
		margin-bottom: 2px;
	}
`;
